import React, { useState, useEffect } from 'react';
import styled from 'astroturf/react';
import OnsitePing, { Props as OnsitePingProps } from './onsite_ping';
import { recordShow } from 'js/utils/dismissibles';
import { Icon } from 'js/design_system/Icon';
import { Button } from 'js/design_system/Button';
import { TextArea } from 'js/design_system/forms/TextArea';
import { Body } from 'js/design_system/Body';
import { fsEvent, initializeFullstory, UserLike } from 'js/fullstory';
import User from 'js/core_post_webpack/models/user';
import * as usher from 'js/utils/usher';
import { createUserContext } from 'js/army_of_grad_students/api';
import trackClick from 'js/utils/trackClick';
import _OuterContainer from "ai_assistant_topic_only_ping-OuterContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=OuterContainer";
import _ContentContainer from "ai_assistant_topic_only_ping-ContentContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=ContentContainer";
import _TopSection from "ai_assistant_topic_only_ping-TopSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=TopSection";
import _WarningContainer from "ai_assistant_topic_only_ping-WarningContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=WarningContainer";
import _WarningTitle from "ai_assistant_topic_only_ping-WarningTitle.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=WarningTitle";
import _BottomSection from "ai_assistant_topic_only_ping-BottomSection.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=BottomSection";
import _QuestionContainer from "ai_assistant_topic_only_ping-QuestionContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=QuestionContainer";
import _QuestionNumber from "ai_assistant_topic_only_ping-QuestionNumber.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=QuestionNumber";
import _FormFieldContainer from "ai_assistant_topic_only_ping-FormFieldContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=FormFieldContainer";
import _LabelDescriptionContainer from "ai_assistant_topic_only_ping-LabelDescriptionContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=LabelDescriptionContainer";
import _QuestionLabel from "ai_assistant_topic_only_ping-QuestionLabel.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=QuestionLabel";
import _QuestionDescription from "ai_assistant_topic_only_ping-QuestionDescription.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=QuestionDescription";
import _ErrorMessage from "ai_assistant_topic_only_ping-ErrorMessage.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=ErrorMessage";
import _TopSectionBody from "ai_assistant_topic_only_ping-TopSectionBody.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/onsite_pings/react/ai_assistant_topic_only_ping.tsx?styleId=TopSectionBody";


interface AiAssistantPingQuestion {
  prompt: string;
  subprompt?: string;
}

interface Props extends OnsitePingProps {
  question: AiAssistantPingQuestion;
  workId?: number;
  user?: UserLike;
}

// Wiggle animation triggered externally by DownloadButtonWrapper
// when users attempt to download before completing the ping
const OuterContainer = /*#__PURE__*/styled("div", null, {
  displayName: "OuterContainer",
  styles: _OuterContainer
});

const ContentContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ContentContainer",
  styles: _ContentContainer
});

const TopSection = /*#__PURE__*/styled("div", null, {
  displayName: "TopSection",
  styles: _TopSection
});

const WarningContainer = /*#__PURE__*/styled("div", null, {
  displayName: "WarningContainer",
  styles: _WarningContainer
});

const WarningTitle = /*#__PURE__*/styled(Body, null, {
  displayName: "WarningTitle",
  styles: _WarningTitle
});

const BottomSection = /*#__PURE__*/styled("div", null, {
  displayName: "BottomSection",
  styles: _BottomSection
});

const QuestionContainer = /*#__PURE__*/styled("div", null, {
  displayName: "QuestionContainer",
  styles: _QuestionContainer
});

const QuestionNumber = /*#__PURE__*/styled(Body, null, {
  displayName: "QuestionNumber",
  styles: _QuestionNumber
});

const FormFieldContainer = /*#__PURE__*/styled("div", null, {
  displayName: "FormFieldContainer",
  styles: _FormFieldContainer
});

const LabelDescriptionContainer = /*#__PURE__*/styled("div", null, {
  displayName: "LabelDescriptionContainer",
  styles: _LabelDescriptionContainer
});

const QuestionLabel = /*#__PURE__*/styled("span", null, {
  displayName: "QuestionLabel",
  styles: _QuestionLabel
});

const QuestionDescription = /*#__PURE__*/styled(Body, null, {
  displayName: "QuestionDescription",
  styles: _QuestionDescription
});

const ErrorMessage = /*#__PURE__*/styled("div", null, {
  displayName: "ErrorMessage",
  styles: _ErrorMessage
});

const TopSectionBody = /*#__PURE__*/styled(Body, null, {
  displayName: "TopSectionBody",
  styles: _TopSectionBody
});

const alreadyAnswered = () =>
  !User.current.admin &&
  window.localStorage.getItem('AI_ASSISTANT_TOPIC_ONLY_PING_COMPLETED');

export default class AiAssistantTopicOnlyPing extends OnsitePing<Props> {
  componentDidMount() {
    if (alreadyAnswered()) {
      return;
    }
    recordShow('AiAssistantTopicOnlyPing');
  }

  renderBasePing(): React.ReactNode {
    return (
      <AiAssistantTopicOnlyPingBody
        question={this.props.question}
        workId={this.props.workId}
        onSubmit={this.handleSubmit}
        user={this.props.user}
      />
    );
  }

  handleSubmit = async (answer: string) => {
    try {
      // Step 1: Get or create the user context and session
      const userContext = await createUserContext('topic_only_ping');

      // Step 2: Show AGS sidebar with the pending message
      const event = new CustomEvent('showAgsSidebar', {
        detail: {
          userContext: userContext,
          pendingMessage: answer.trim(),
        },
      });
      window.dispatchEvent(event);

      // Remove the download prevention div so downloads work after dismissal
      const preventDownloadDiv = document.getElementById(
        'ai-assistant-topic-only-ping-prevent-download',
      );
      if (preventDownloadDiv) {
        preventDownloadDiv.remove();
      }

      // Dismiss the ping using the base class method
      const dismissHandler = this.createCloseTooltip(this.props.pingName);
      // Call with a minimal event object since we're calling programmatically
      dismissHandler({ preventDefault: () => {} } as React.BaseSyntheticEvent);
    } catch (error) {
      console.error('Failed to submit topic:', error);
      // Still allow dismissal even if submission fails
      const preventDownloadDiv = document.getElementById(
        'ai-assistant-topic-only-ping-prevent-download',
      );
      if (preventDownloadDiv) {
        preventDownloadDiv.remove();
      }
      const dismissHandler = this.createCloseTooltip(this.props.pingName);
      dismissHandler({ preventDefault: () => {} } as React.BaseSyntheticEvent);
    }
  };
}

type BodyProps = {
  question: AiAssistantPingQuestion;
  workId?: number;
  onSubmit: (answer: string) => void;
  user?: UserLike;
};

const DEFAULT_PLACEHOLDER = 'Climate change impacts on agriculture';
const PLACEHOLDER_TIMEOUT = 10000; // 10 seconds
const MAX_INPUT_LENGTH = 2000;

const AiAssistantTopicOnlyPingBody: React.FC<BodyProps> = ({
  question,
  workId,
  onSubmit,
  user,
}) => {
  const [answer, setAnswer] = useState('');
  const [placeholder, setPlaceholder] = useState<string | null>(null);
  const [showError, setShowError] = useState(false);

  // Initialize FullStory sampling on mount
  useEffect(() => {
    if (user) {
      initializeFullstory(user, true);
      fsEvent('AiAssistantTopicOnlyPing_Mounted');
    }
  }, [user]);

  useEffect(() => {
    if (!workId) {
      setPlaceholder(DEFAULT_PLACEHOLDER);
      return;
    }

    let isMounted = true;
    const timeoutId = setTimeout(() => {
      if (isMounted) {
        setPlaceholder(DEFAULT_PLACEHOLDER);
      }
    }, PLACEHOLDER_TIMEOUT);

    usher
      .invoke('generate_topic_placeholder', workId, {})
      .then((result) => {
        if (isMounted) {
          clearTimeout(timeoutId);
          setPlaceholder(result || DEFAULT_PLACEHOLDER);
        }
      })
      .catch(() => {
        if (isMounted) {
          clearTimeout(timeoutId);
          setPlaceholder(DEFAULT_PLACEHOLDER);
        }
      });

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [workId]);

  const handleAnswerChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setAnswer(value);

    // Clear error when user starts typing
    if (showError && value.trim().length > 0) {
      setShowError(false);
    }
  };

  const handleSubmit = () => {
    if (answer.trim()) {
      trackClick({
        source: 'ags.topic_only_ping_submit',
      });

      onSubmit(answer.trim());
      window.localStorage.setItem(
        'AI_ASSISTANT_TOPIC_ONLY_PING_COMPLETED',
        'true',
      );
    } else {
      setShowError(true);
    }
  };

  // Don't render anything until placeholder is ready
  if (!placeholder) {
    return null;
  }

  return (
    <>
      <div
        id="ai-assistant-topic-only-ping-prevent-download"
        style={{ visibility: 'hidden' }}
      />
      <OuterContainer id="ai-assistant-topic-only-ping-container">
        <ContentContainer>
          <TopSection>
            <WarningContainer>
              <Icon name="error" size={20} />
              <WarningTitle as="span">
                Answer required to view paper
              </WarningTitle>
            </WarningContainer>
            <TopSectionBody>
              Your AI Assistant can learn to filter papers just like you. No
              more keyword searching. No more trudging through "almost relevant"
              papers. Share your research topic to get started.
            </TopSectionBody>
          </TopSection>
          <BottomSection>
            <QuestionContainer>
              <QuestionNumber as="span">Question 1 of 1</QuestionNumber>
              <FormFieldContainer>
                <LabelDescriptionContainer>
                  <QuestionLabel id="question-label">
                    {question.prompt}
                  </QuestionLabel>
                  {question.subprompt && (
                    <QuestionDescription
                      id="question-description"
                      style={{ marginBottom: '22px' }}
                    >
                      {question.subprompt}
                    </QuestionDescription>
                  )}
                </LabelDescriptionContainer>
                <TextArea
                  value={answer}
                  placeholder={placeholder}
                  onChange={handleAnswerChange}
                  rows={5}
                  maxLength={MAX_INPUT_LENGTH}
                  aria-labelledby="question-label"
                  aria-describedby={
                    question.subprompt ? 'question-description' : undefined
                  }
                  aria-required="true"
                  hasError={showError}
                />
                <ErrorMessage visible={showError}>
                  <Icon name="warning" size={20} />
                  Required to view paper
                </ErrorMessage>
              </FormFieldContainer>
            </QuestionContainer>
            <Button onClick={handleSubmit} iconRight="arrow_forward" fullWidth>
              Submit and view PDF
            </Button>
          </BottomSection>
        </ContentContainer>
      </OuterContainer>
    </>
  );
};
